import React, {Component} from "react";
import styles from "./home.less";
import moment from 'moment';
import {Space, Row, Col, Form, Input, DatePicker, TimePicker, Typography, Switch, Button, Spin, notification} from 'antd';
import { Layout } from "antd";
import RangePicker from "react-range-picker"
import db from "../../firebase.config";
import { withRouter } from "react-router-dom";

const {Content, Footer, Header} = Layout;
const { Paragraph } = Typography;
// const { RangePicker: AntRangePicker } = DatePicker;
const timeFormat = 'HH:mm';
const dateFormat = 'DD/MM/yyyy'

const rangePickerFooter = ({close}) => {
    return (
        <div className="range-picker-footer">
            <Button type="primary" onClick={close}>OK</Button>
        </div>
    );
}

const placeholder = ({startDate, endDate}) => {
    return (
        <Input value={`${moment(startDate).format(dateFormat)} - ${moment(endDate).format(dateFormat)}`}/>
    );
}
const NewRangePicker = ({onChange}) => {
    const onDateChanges = (fromDate, toDate) => {
        onChange([moment(fromDate), moment(toDate)])
    }
    return (
     <RangePicker
         onDateSelected={onDateChanges}
         placeholder={placeholder}
         footer={rangePickerFooter}
     />
    );
}

const HourPicker = (props) => {
    const { value, onChangeDate, onChangeStartHour, onChangeEndHour } = props;
    const { date, startHour, endHour } = value;

    return (
        <Space size="small">
            <div>
                <span>Ngày đặt</span>
                <DatePicker {...props} value={date} format={dateFormat} onChange={onChangeDate}/>
            </div>
            <div>
                <span>Giờ check-in</span>
                <TimePicker {...props} value={startHour} format={timeFormat} onChange={onChangeStartHour} />
            </div>
            <div>
                <span>Giờ check-out</span>
                <TimePicker {...props} value={endHour} format={timeFormat} onChange={onChangeEndHour} />
            </div>
        </Space>
    );
}

const DaysPicker = (props) => {
    return (
        <Space direction="vertical">
            <div>Ngày check-in và check-out</div>
            <NewRangePicker {...props} />
        </Space>
    );
}

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateRange: null,
            name: null,
            phone: null,
            selectionRange: [moment().add(1, "d"), moment().add(2, "d")],
            hoursSelection: {
                date: moment(),
                startHour: moment('14:00', timeFormat),
                endHour: moment('16:00', timeFormat)
            },
            isHours: false,
            requiredMark: "optional",
            price: 0,
            isLoading: false,
        }
        this.handleSelect = this.handleSelect.bind(this);
        this.setIsHours = this.setIsHours.bind(this);
        this.onRequiredTypeChange = this.onRequiredTypeChange.bind(this);
        this.setSelectionRange = this.setSelectionRange.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.onChangeStartHour = this.onChangeStartHour.bind(this);
        this.onChangeEndHour = this.onChangeEndHour.bind(this);
        this.setPrice = this.setPrice.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    setPrice() {
        this.setState((state) => {
            if (state.isHours) {
                const { startHour, endHour } = state.hoursSelection;
                const duration = moment.duration(endHour.diff(startHour));
                const hours = duration.asHours();
                return {
                    price: 350 + (hours - 1) * 50,
                }
            } else {
                if (!state.selectionRange) {
                    return {
                        price: 0
                    }
                }
                const [ startDate, endDate ] = state.selectionRange;
                if (startDate && endDate && endDate.diff(startDate, "d") > 0) {
                    const price = [...Array(endDate.diff(startDate, "d")).keys()].reduce((acc, d) => {
                        const weekDay = startDate.add(d, "d").day();
                        if (weekDay !== 5 && weekDay !== 6) {
                            return acc + 550;
                        } else {
                            return acc + 650;
                        }
                    }, 0);
                    return {
                        price: price
                    }
                }
                return {
                    price: 0,
                }
            }

        })
    }

    onRequiredTypeChange({ requiredMarkValue }) {
        this.setState(() => ({
            requiredMark: requiredMarkValue,
        }));
    };

    handleSelect(ranges){
        this.setState(() => ({
            selectionRange: ranges.selection
            })
        )
    }

    disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day') && current > moment().add(1, "month");
    }

    setIsHours(value) {
        this.setState(() => ({
            isHours: value
        }), this.setPrice);
    }

    onFormSubmit(formData) {
        const { name, phone, peopleNum } = formData;
        const { isHours, selectionRange, hoursSelection, price } = this.state;
        const [startDate, endDate] = selectionRange ? selectionRange : [null , null];
        const {date, startHour, endHour} = hoursSelection;
        this.setState((state) => ({
            isLoading: true,
        }));
        const data = {
            name,
            phone,
            peopleNum,
            isHours,
            startDate: startDate ? startDate.format(dateFormat) : '',
            endDate: endDate ? endDate.format(dateFormat) : '',
            date: date ? date.format(dateFormat) : '',
            startHour: startHour ? startHour.format(timeFormat) : '',
            endHour: endHour ? endHour.format(timeFormat) : '',
            price
        }
        db.collection("booking").add(data).then(() => {
            this.setState((state) => ({
                isLoading: false,
            }));
            this.props.history.push({
                pathname: '/success',
                state: data,
            });
        }).catch(() => {
            this.setState((state) => ({
                isLoading: false,
            }));
            notification["error"]({
                message: "Có lỗi xảy ra",
                description: "Đặt phòng không thành công. Bạn vui lòng thử lại sau.",
                placement: "bottomLeft",
                duration: 2,
            });
        });
    }

    setSelectionRange(dates, dateStrings) {
        this.setState(() => ({
            selectionRange: dates,
        }), this.setPrice);
    }

    onChangeDate(date) {
        this.setState((state) => ({
            hoursSelection: {
                date: date,
                startHour: state.hoursSelection.startHour,
                endHour: state.hoursSelection.endHour
            }
        }));
    }

    onChangeStartHour(hour) {
        this.setState((state) => ({
            hoursSelection: {
                date: state.hoursSelection.date,
                startHour: hour,
                endHour: state.hoursSelection.endHour
            }
        }), this.setPrice);
    }

    onChangeEndHour(hour) {
        this.setState((state) => ({
            hoursSelection: {
                date: state.hoursSelection.date,
                startHour: state.hoursSelection.startHour,
                endHour: hour
            }
        }), this.setPrice);
    }

    render() {
        return (
            <Layout>
                <Header>
                    Olala Homestay Booking
                </Header>
                <Content className="content-body">
                    <Row justify="start">
                        <Col span={24}>
                            <Paragraph className="sub-paragraph">Cảm ơn bạn đã đến với trang đặt phòng của Olala Homestay, mời bạn chọn thời gian và thông tin người đặt, chúng tôi sẽ hướng dẫn bạn check-in và sử dụng các tiện nghi tại Olala Homestay</Paragraph>
                        </Col>
                    </Row>
                    <Row justìy="start">
                        <Col span={24}>
                            <div className="sub-header">Vui lòng chọn thời gian</div>
                            <Form
                                layout="vertical"
                                name="userInfo"
                                labelCol={{span: 4}}
                                wrapperCol={{span: 8}}
                                onFinish={this.onFormSubmit}
                                initialValues={{peopleNum: 2}}
                            >
                                <Form.Item>
                                    <Space className="booking-switch">
                                        <span className={`booking-tag ${!this.state.isHours ? 'booking-tag-selected' : ''}`}>Theo ngày</span>
                                        <span className="is-hours-switch-wrapper">
                                    <Switch
                                        checked={this.state.isHours}
                                        onChange={this.setIsHours}
                                    />
                                </span>
                                        <span className={`booking-tag ${this.state.isHours ? 'booking-tag-selected' : ''}`}>Theo giờ</span>
                                    </Space>
                                    <div className="booking-hour-selector">
                                        { this.state.isHours ?
                                            <HourPicker
                                                value={this.state.hoursSelection}
                                                onChangeDate={this.onChangeDate}
                                                onChangeStartHour={this.onChangeStartHour}
                                                onChangeEndHour={this.onChangeEndHour}
                                            /> :
                                            <DaysPicker
                                                disabledDate={this.disabledDate}
                                                value={this.state.selectionRange}
                                                onChange={this.setSelectionRange}
                                                placeholder={["Từ ngày", "Tới ngày"]}
                                            />
                                        }
                                    </div>
                                </Form.Item>
                                <Form.Item
                                    label="Số người"
                                    name="peopleNum"
                                    rules={[{ required: true, message: 'Vui lòng nhập số người' }]}
                                >
                                    <Input type="number"/>
                                </Form.Item>
                                <Form.Item
                                    label="Tên người đặt"
                                    name="name"
                                    rules={[{ required: true, message: 'Vui lòng nhập tên' }]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label="Số điện thoại (Zalo)"
                                    name="phone"
                                    rules={[{ required: true, message: "Vui lòng nhập số điện thoại" }]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label="Tiền phòng (tạm tính)"
                                >
                                    <Input disabled value={this.state.price ? this.state.price + "k" : "0k"}/>
                                </Form.Item>
                                <Form.Item
                                >
                                    <Button disabled={this.state.isLoading} type="primary" htmlType="submit" className="submit-button">
                                        {this.state.isLoading ? <Spin /> : ''} Đặt phòng
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>

                </Content>
                <Footer>
                    Toà G3, KĐT Vinhomes Green Bay, phường Mễ Trì, quận Nam Từ Liêm, Hà Nội
                </Footer>
            </Layout>
        );
    }
}

export default withRouter(Home);
